import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2s1gu6rdak: FaireBrandEntity = {
  token: "b_2s1gu6rdak",
  type: "brand",
  name: "Vine & Love",
  avatarUrl:
    "https://cdn.faire.com/fastly/8a83333d5837b7061ad528e8dc5283ee688b22e68f18a9df4113eb8fda00bb1b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/013bb13c46344fd1e1e6e6ba3e9bbc5afecf5fd948d52c878126d313e9c30820.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8a83333d5837b7061ad528e8dc5283ee688b22e68f18a9df4113eb8fda00bb1b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/013bb13c46344fd1e1e6e6ba3e9bbc5afecf5fd948d52c878126d313e9c30820.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 418,
  isTopShop: true,
  isInsider: true,
  description:
    "Vine and Love is the premier destination for young contemporary and missy women's clothing in the heart of Los Angeles. At Vine and Love, we believe that fashion is a form of self-expression, and we are dedicated to offering a wide range of apparel that caters to every woman's unique sense of style. Our expertly curated collection is constantly updated with the latest trends, ensuring that our customers stay ahead of the fashion curve.  From seamless order processing to lightning-fast shipping, we go above and beyond to make your satisfaction our top priority. Discover your style at Vine and Love and let us help you look and feel your best.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:37.768Z",
    importedBy: "entity-db-cli",
  },
};
